import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_DATA_ARCHIVAL_REPORT_DOWNLOAD_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request / Response
// =============================================================================

interface DownloadDataArchivalReportRequest {
  uuid: string;
  contentDisposition: string;
}

interface DownloadDataArchivalReportResponse {
  fileStatus: string;
  fileName: string;
  url: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: DownloadDataArchivalReportResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useDownloadDataArchivalReport = ({ onSuccess, onError }: Input) => {
  const postDownloadDataArchivalReport = async (payload: DownloadDataArchivalReportRequest) => {
    const res = await axiosClient.post<DownloadDataArchivalReportResponse>(
      POST_DATA_ARCHIVAL_REPORT_DOWNLOAD_URL,
      payload
    );
    return res.data;
  };

  return useCustomMutation(postDownloadDataArchivalReport, {
    onSuccess,
    onError,
  });
};
